import { useParams } from "react-router-dom";
import PrepareBillingForm from "./PrepareBillingForm";
import { checkPermission } from "./config/checkPermission";
import { useCallback, useEffect, useMemo, useState } from "react";
import { CNF_PREPARE_BILLING_SHOW_ENDPOINT } from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import { message } from "antd";

export default function UpdatePrepareBilling() {
  const { prepareBillingId } = useParams();
  const loggedInUserId = parseInt(localStorage.getItem("user_id"), 10);
  const loggedInUserRole = localStorage.getItem("user_type");
  const [editInfo, setEditInfo] = useState(null);

  const load = useCallback(async (id) => {
    const response = await getData(`${CNF_PREPARE_BILLING_SHOW_ENDPOINT}/${id}`);
    if (response?.status === 200 && response?.data?.code === 200) {
      setEditInfo(response.data.data);
    } else {
      message.error("Could not load prepare billing.");
    }
  }, []);

  useEffect(() => {
    if (prepareBillingId) load(prepareBillingId);
  }, [prepareBillingId, load]);

  const isCreator = editInfo && loggedInUserId === editInfo?.user?.id;

  const canUpdate = useMemo(() => {
    if (!editInfo) return false;
    return checkPermission(
      loggedInUserRole,
      editInfo.status,
      isCreator,
      "update",
      editInfo?.department_approve,
      editInfo?.director_approve,
    );
  }, [editInfo, loggedInUserRole, isCreator]);

  const canEditApprovedAmount = useMemo(() => {
    if (!editInfo) return false;
    return checkPermission(
      loggedInUserRole,
      editInfo.status,
      isCreator,
      "editApprovedAmount",
      editInfo?.department_approve,
      editInfo?.director_approve,
    );
  }, [editInfo, loggedInUserRole, isCreator]);

  return (
    <PrepareBillingForm
      isEdit
      prepareBillingId={prepareBillingId}
      editInfo={editInfo}
      viewMode={!canUpdate && !canEditApprovedAmount}
      canUpdate={canUpdate}
      canEditApprovedAmount={canEditApprovedAmount}
    />
  );
}
